import { __spreadArray } from 'tslib';

var isEmptyArray = function (obj) {
    return Array.isArray(obj) && obj.length < 1;
};
var coalesce = function (item) {
    if (!item) {
        return [];
    }
    else if (Array.isArray(item)) {
        return item;
    }
    else {
        return [item];
    }
};
var intersperse = function (x, xs) {
    if (xs === void 0) { xs = []; }
    return xs.reduce(function (acc, curr, idx) { return (1 + idx === xs.length ? __spreadArray(__spreadArray([], acc, true), [curr], false) : __spreadArray(__spreadArray([], acc, true), [curr, x], false)); }, []);
};
var partition = function (xs, predicate) {
    return xs.reduce(function (acc, curr) {
        if (predicate(curr)) {
            acc[0].push(curr);
        }
        else {
            acc[1].push(curr);
        }
        return acc;
    }, [[], []]);
};
var range = function (end, startAt) {
    if (startAt === void 0) { startAt = 0; }
    return Array.from({ length: end }, function (_, i) { return i; }).filter(function (i) { return i >= startAt; });
};

export { coalesce, intersperse, isEmptyArray, partition, range };
